import { CircleDot } from "lucide-react";

/**
 * Badge discreto pra indicar que a página está em modo demo (mock data).
 * Aparece quando a API falhou e o componente caiu em fallback. Cinza
 * pequeno, mesma palette da LockedBadge — não compete visualmente com
 * KPIs / gráficos.
 */
export function DataSourceBadge({
  label = "modo demo",
  title = "Falha ao conectar com /api/fluxo — exibindo dados de exemplo",
}: {
  label?: string;
  title?: string;
}) {
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-white/50 bg-white/5 px-2 py-0.5 rounded"
      data-testid="data-source-badge"
      title={title}
    >
      <CircleDot size={10} />
      {label}
    </span>
  );
}
